import { derived, writable } from 'svelte/store';

interface ExportLinearDialogState {
	open: boolean;
	taskIds: string[];
	memoryId?: string;
}

const initialState: ExportLinearDialogState = {
	open: false,
	taskIds: [],
	memoryId: undefined
};

const exportLinearDialogState = writable<ExportLinearDialogState>(initialState);

export const exportLinearDialogOpen = {
	subscribe: derived(exportLinearDialogState, (state) => state.open).subscribe,
	set: (value: boolean) => {
		exportLinearDialogState.update((state) => ({
			...state,
			open: value
		}));
		if (!value) {
			exportLinearDialogState.set(initialState);
		}
	}
};

export const exportLinearDialogStore = exportLinearDialogState;

export const openExportToLinearDialog = (options: { taskIds?: string[]; memoryId?: string }) => {
	exportLinearDialogState.set({
		open: true,
		taskIds: options.taskIds ?? [],
		memoryId: options.memoryId
	});
};

export const closeExportToLinearDialog = () => {
	exportLinearDialogState.set(initialState);
};
